export default class sales_area_data {
  constructor(sales_organization, distribution_channel, division) {
    this.sales_organization = sales_organization;
    this.distribution_channel = distribution_channel;
    this.division = division;
  }
}
